import { ADD_CLIENT,ADD_CLIENT_SUCCESS, ADD_CLIENT_FAIL, UPDATE_CLIENT_LOADING,UPDATE_CLIENT, UPDATE_CLIENT_SUCCESS, UPDATE_CLIENT_FAIL  } from "./actionType";

const initialState = {
    // client: null,
    // user: null,
    error: "",
    success: "",
    loader: false
}

const AddClient01 = (state = initialState, action) => {
    switch (action.type) {
        case ADD_CLIENT:
            state = {
                ...state,
                loading: true,
            };
            break;
        case UPDATE_CLIENT_LOADING:
            state = {
                ...state,
                loader: action.payload,
            }
        case ADD_CLIENT_SUCCESS:
            state = { ...state, success: action.payload,loading: false };
            break;
        case ADD_CLIENT_FAIL:
            state = { ...state, error: action.payload, loading: false  };
            break;
        case UPDATE_CLIENT_SUCCESS:
            return {
                ...state,
                user: action.payload,
                loading: false 
            }

        case UPDATE_CLIENT_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false 
            }
    }
    return state;
};

export default AddClient01;